import styled from 'styled-components';

import { DeprecatedGrid as Grid } from '@simplywallst/ui-core';

export const StyledCompanyFeed = styled(Grid)`
  margin-top: ${({ theme }) => theme.x3spacePx}px;
  margin-left: -8px;
  margin-right: -8px;
`;

export const Container = styled('div')`
  padding-top: ${(props) => props.theme.x2spacePx}px;
`;
